export default {
  selectSurvey: {
    heading: 'Seleccionar encuesta',
    headingDefault: 'Seleccionar encuesta predeterminada',
    noDefault: 'No existe encuesta predeterminada'
  }
};